// TODO: remove this file and all styled components usages
import { env } from 'constants';
import { getStaticConfig } from 'utils/config';

const palette = getStaticConfig('general.theme.palette');
export const theme = {
  colors: {
    primary: palette?.primary0 || palette?.primary || env.PRIMARY_COLOR || '#aaa',
    primaryLight90: `${palette?.primary90}`,
    primaryLight80: `${palette?.primary80}`,
    primaryLight60: `${palette?.primary60}`,
    primaryDark20: `${palette?.primary20}`,
    primaryDark10: `${palette?.primary10}`,
    textPrimary: '#131B1F',
    grayLight10: '#2B3235',
    grayLight20: '#42494C',
    grayLight30: '#5A5F62',
    grayLight50: '#898D8F',
    grayLight65: '#ACAFB1',
    grayLight70: '#B8BBBC',
    grayLight75: '#C4C6C7',
    grayLight80: '#D0D1D2',
    grayLight85: '#DCDDDD',
    grayLight90: '#E7E8E9',
    grayLight95: '#F3F4F4',
    success: '#009047',
    success20: '#007339',
    success30: '#006532',
    success60: '#33A66C',
    success80: '#F2F9F6',
    error: '#E6272A',
    error20: '#EB5255',
    error95: '#FEF4F4',
    warning: '#FECD51',
    warning5: '#F1C34D',
    default: '#1267FB',
    defaultLight90: '#E7F0FF',
    defaultDark20: '#0E52C9',
    defaultDark30: '#0D48B0',
    default90: '#E7F0FF',
    white: '#FFFFFF',
    black: '#000000',
  },
  spacing: {
    s1half: '2px',
    s1: '4px',
    s2: '8px',
    s3: '12px',
    s4: '16px',
    s5: '20px',
    s6: '24px',
    s7: '28px',
    s8: '32px',
    s9: '36px',
    s10: '40px',
    s12: '48px',
    s14: '56px',
    s16: '64px',
    s18: '72px',
    s20: '80px',
  },
};
